import flatpickr from 'flatpickr'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

import 'flatpickr/dist/flatpickr.min.css'

flatpickr.localize(Japanese)

function attachPickerWithClear(selector, options = {}) {
  document.querySelectorAll(selector).forEach((input) => {
    const fp = flatpickr(input, options)

    const btn = document.createElement('button')
    btn.type = 'button'
    btn.textContent = '×'
    btn.className = 'flatpickr-clear-btn'
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      fp.clear()
      fp.close()
      input.dispatchEvent(new Event('input', { bubbles: true }))
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
    input.insertAdjacentElement('afterend', btn)
  })
}

window.addEventListener('DOMContentLoaded', () => {
  flatpickr(".js-date-picker", {})
  flatpickr(".js-datetime-picker", { enableTime: true })
  flatpickr(".js-time-picker", {enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true})
  attachPickerWithClear(".js-date-picker-clear", {})
  attachPickerWithClear(".js-time-picker-clear", {enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true})
})
